module.exports = __webpack_public_path__ + "static/media/popular.df079d0f.jpg";